import { useCallback, useRef } from 'react';

import { useHandlePanelPlacement } from 'app/modules/wallforming/components/setting-container/hooks/useHandlePanelPlacement';
import { usePanelPlacementSubscriptions } from 'app/modules/wallforming/components/setting-container/hooks/usePanelPlacementSubscriptions';
import { PanelPlacementButton } from 'app/modules/wallforming/components/setting-container/panel-placement/PanelPlacementButton';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import type { Article } from 'app/modules/wallforming/components/scenes/objects/articles/types/article';
import type { Poi } from 'app/modules/wallforming/components/scenes/objects/pois/types/poi';

interface PanelPlacementActionProps {
    articleDataLoaded: boolean;
}

export const PanelPlacementAction = ({ articleDataLoaded }: PanelPlacementActionProps) => {
    const placementButtonRef = useRef<HTMLButtonElement | null>(null);

    const poisRef = useRef<Poi[] | undefined>(usePlacementStore.getState().pois);
    const selectedPoiIndexRef = useRef<number | undefined>(usePlacementStore.getState().poiSelection.current.index);

    const articlesRef = useRef<Record<string, Article>>(usePlacementStore.getState().articles);
    const isAutoFormworkEnabledRef = useRef<boolean>(true);

    const { handlePanelPlacementStart, isAutomatedPanelPlacementLoading } = useHandlePanelPlacement();

    const updateActionIcon = useCallback(() => {
        const isEnabled =
            articleDataLoaded &&
            selectedPoiIndexRef.current !== undefined &&
            !!poisRef.current;

        isAutoFormworkEnabledRef.current = isEnabled ?? false;

        if (placementButtonRef.current) {
            placementButtonRef.current.disabled = !isAutoFormworkEnabledRef.current || isAutomatedPanelPlacementLoading;
        }
    }, [articleDataLoaded, isAutomatedPanelPlacementLoading]);

    usePanelPlacementSubscriptions({
        selectedPoiIndexRef,
        poisRef,
        articlesRef,
        updateActionIcon
    });

    return (
        <PanelPlacementButton
            articleDataLoaded={articleDataLoaded}
            handlePanelPlacementStart={handlePanelPlacementStart}
            isAutoFormworkEnabledRef={isAutoFormworkEnabledRef}
            isAutomatedPanelPlacementLoading={isAutomatedPanelPlacementLoading}
            placementButtonRef={placementButtonRef}
            updateActionIcon={updateActionIcon}
        />
    );
};
